import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Table } from 'antd'
import { useAuth } from '../../../context/auth-context'
import { useDateTime } from '../../../shared/useDateTime'
import { useAmountAndCurrency } from '../../../shared/useAmountAndCurrency'
import PerText from '../../../components/custom_components/Text'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import { TargetCorrectionPaymentDto } from '../../../types'
import { useCurrency } from '../../../context/currency-context'

interface Props {
  targetCorrectionPayment: TargetCorrectionPaymentDto
  showSpacer?: boolean
}

export const ConclusionTargetCorrectionPayment: FC<Props> = ({ targetCorrectionPayment, showSpacer = true }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { formatDateMonthYear } = useDateTime(user)
  const { formatCurrency } = useAmountAndCurrency(user.locale)
  const { currency } = useCurrency()

  const columns = [
    {
      key: 'comment',
      title: t('appraisalMeeting.targetCorrectionPayment.title'),
      dataIndex: 'comment',
      render: (comment: string) => <PerText fontWeight="bold">{comment}</PerText>,
    },
    {
      key: 'resultAmount',
      title:
        t('okr.objective.monetary.toBePaid') +
        ' ' +
        t('appraisalMeeting.targetCorrectionPayment.titleIn') +
        ' ' +
        formatDateMonthYear(targetCorrectionPayment.paymentDate, true),
      dataIndex: 'resultAmount',
      className: 'textAlign-right',
      render: (resultAmount: number) => <PerText color={'primary'}>{formatCurrency(resultAmount, currency, true)}</PerText>,
    },
  ]

  return (
    <>
      {!!targetCorrectionPayment && (
        <div data-e2e-oneoff-conclusion>
          {!!showSpacer && (
            <PerFlexRow justify="space-between" align="middle" mb="s">
              <PerFlexRow align="middle">&nbsp;</PerFlexRow>
            </PerFlexRow>
          )}
          <Table dataSource={[{ ...targetCorrectionPayment, key: 0 }]} columns={columns} pagination={false} />
        </div>
      )}
    </>
  )
}
